import { getBusinessProfile } from '../config/business-profiles';

/** Catégories « restauration » au sens TVA réduite 5,5 % (repas sur place / à emporter préparés) */
const RESTAURATION_CATEGORIES = new Set([
  'RESTAURANT',
  'PIZZERIA',
  'FAST_FOOD',
  'SUSHI',
  'CUISINE_ETHNIQUE',
  'TRAITEUR',
  'BAR_TAPAS',
]);

export const TVA_TAUX_NORMAL = 20;
export const TVA_TAUX_RESTAURATION = 5.5;

export const TVA_RATE_OPTIONS = [
  { value: TVA_TAUX_RESTAURATION, label: '5,5 % — Restauration (repas, taux réduit)' },
  { value: TVA_TAUX_NORMAL, label: '20 % — Taux normal (majorité des commerces)' },
  { value: 10, label: '10 % — Taux intermédiaire (si applicable)' },
];

export function isRestaurationCategorie(categorie) {
  if (!categorie) return false;
  const key = String(categorie).toUpperCase();
  const profile = getBusinessProfile(key);
  if (profile?.type === 'restauration') return true;
  return RESTAURATION_CATEGORIES.has(key);
}

export function getDefaultTauxTVA(categorie) {
  return isRestaurationCategorie(categorie) ? TVA_TAUX_RESTAURATION : TVA_TAUX_NORMAL;
}

export function normalizeTauxTVAInput(value, categorie) {
  const parsed = parseFloat(value);
  if (Number.isFinite(parsed) && parsed >= 0 && parsed <= 100) return parsed;
  return getDefaultTauxTVA(categorie);
}
